<div *ngIf="route$ | async as route; else loading">
  <div class="modal-content">
    <div class="modal-header justify-content-start d-print-none">
      <app-report-header [routeName]="route.name"></app-report-header>
      <i class="material-icons ml-auto text-secondary d-print-none">print</i>
      <button
        type="button"
        gtagEvent
        trackOn="click"
        action="Print_Current_Report"
        category="Reports"
        [params]="{ event_label: 'print current report clicked' }"
        class="btn btn-sm btn-outline-primary ml-3"
        (click)="printReport()"
      >
        Print Current Report
      </button>
      <button
        type="button"
        gtagEvent
        trackOn="click"
        action="Print_All_Reports"
        category="Reports"
        [params]="{ event_label: 'print all reports clicked' }"
        class="btn btn-sm btn-outline-primary ml-2"
        (click)="printAllReports()"
      >
        Print All Reports
      </button>

      <button
        type="button"
        class="btn btn-icon-only pt-0"
        (click)="downloadCSV()"
      >
        <div
          class="export-logo"
          tooltip="Export As CSV"
          container="body"
          [adaptivePosition]="false"
          placement="bottom"
        ></div>
      </button>
    </div>
    <div class="modal-body">
      <app-report-summary
        class="d-print-none"
        [route]="route"
        [displayCurrency]="displayCurrency"
      ></app-report-summary>
      <ng-container
        *ngIf="{
          historicalDataVersion: checkDataVersion$ | async
        } as c"
      >
        <ul
          class="nav nav-tabs nav-tabs-sm mt-3 d-print-none"
          id="reportsTab"
          role="tablist"
        >
          <li
            class="nav-item"
            *ngIf="!isStandardUser && !c.historicalDataVersion"
          >
            <a
              class="nav-link"
              gtagEvent
              trackOn="click"
              action="Detailed_Route"
              category="Reports"
              [params]="{ event_label: 'Detailed Route clicked' }"
              id="detailedRouteTab"
              data-toggle="tab"
              href="#detailedRoute"
              role="tab"
              aria-controls="detailedRoute"
              aria-selected="true"
              [ngClass]="{ active: !showWarningReport }"
              >Detailed Route</a
            >
          </li>
          <li
            class="nav-item"
            *ngIf="!isStandardUser && !c.historicalDataVersion"
          >
            <a
              class="nav-link"
              gtagEvent
              trackOn="click"
              action="Driving_Directions"
              category="Reports"
              [params]="{ event_label: 'Driving Directions clicked' }"
              id="drivingDirectionsTab"
              data-toggle="tab"
              href="#drivingDirections"
              role="tab"
              aria-controls="drivingDirections"
              aria-selected="false"
              [ngClass]="{ active: showWarningReport }"
              >Driving Directions</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              gtagEvent
              trackOn="click"
              action="State/Country_Distances"
              category="Reports"
              [params]="{ event_label: 'State/Country Distances clicked' }"
              id="stateCountryDistancesTab"
              data-toggle="tab"
              href="#stateCountryDistances"
              role="tab"
              aria-controls="stateCountryDistances"
              aria-selected="false"
              [ngClass]="{
                active: isStandardUser || c.historicalDataVersion
              }"
              >State/Country Distances</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              gtagEvent
              trackOn="click"
              action="Road_Type_Distances"
              category="Reports"
              [params]="{ event_label: 'Road Type Distances clicked' }"
              id="roadTypeDistancesTab"
              data-toggle="tab"
              href="#roadTypeDistances"
              role="tab"
              aria-controls="roadTypeDistances"
              aria-selected="false"
              >Road Type Distances</a
            >
          </li>
          <li class="nav-item" *ngIf="isEuRegion">
            <a
              class="nav-link"
              gtagEvent
              trackOn="click"
              action="Toll_Details"
              category="Reports"
              [params]="{ event_label: 'Toll Details clicked' }"
              id="tollTypeTab"
              data-toggle="tab"
              href="#tollType"
              role="tab"
              aria-controls="tollType"
              aria-selected="false"
              >Toll Details</a
            >
          </li>
        </ul>

        <div
          class="tab-content py-3"
          id="reportsTabContent"
          [ngClass]="{ 'print-all-reports': shouldPrintAllReports }"
          #reportTab
        >
          <div
            class="tab-pane fade"
            id="detailedRoute"
            role="tabpanel"
            aria-labelledby="detailedRouteTab"
            *ngIf="!isStandardUser && !c.historicalDataVersion"
            [ngClass]="{
              'show active': !showWarningReport && !c.historicalDataVersion
            }"
          >
            <app-detail-report
              [route]="route"
              [precision]="precision$ | async"
              [distanceUnits]="route?.optionsState?.distanceUnits"
              [displayCurrency]="displayCurrency"
              [printView]="shouldPrintAllReports"
              (exportCSV)="downloadFile($event)"
            ></app-detail-report>
          </div>
          <div
            class="tab-pane fade"
            id="drivingDirections"
            role="tabpanel"
            aria-labelledby="drivingDirectionsTab"
            *ngIf="!isStandardUser && !c.historicalDataVersion"
            [ngClass]="{
              'show active': showWarningReport && !c.historicalDataVersion
            }"
          >
            <app-driving-directions-report
              [route]="route"
              [precision]="precision$ | async"
              [distanceUnits]="route?.optionsState?.distanceUnits"
              [printView]="shouldPrintAllReports"
            ></app-driving-directions-report>
          </div>
          <div
            class="tab-pane fade"
            id="stateCountryDistances"
            role="tabpanel"
            aria-labelledby="stateCountryDistancesTab"
            [ngClass]="{
              active: isStandardUser || c.historicalDataVersion,
              show: isStandardUser || c.historicalDataVersion
            }"
          >
            <app-state-country-distance-report
              [route]="route"
              [precision]="precision$ | async"
              [distanceUnits]="route?.optionsState?.distanceUnits"
              [displayCurrency]="displayCurrency"
              [isStandardUser]="isStandardUser"
              [printView]="shouldPrintAllReports"
            ></app-state-country-distance-report>
          </div>
          <div
            class="tab-pane fade"
            id="roadTypeDistances"
            role="tabpanel"
            aria-labelledby="roadTypeDistancesTab"
          >
            <app-road-type-distance-report
              [route]="route"
              [precision]="precision$ | async"
              [distanceUnits]="route?.optionsState?.distanceUnits"
            ></app-road-type-distance-report>
          </div>
          <div
            *ngIf="isEuRegion"
            class="tab-pane fade"
            id="tollType"
            role="tabpanel"
            aria-labelledby="tollTypeTab"
          >
            <app-toll-type-report
              [precision]="precision$ | async"
              [route]="route"
            ></app-toll-type-report>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-outline-dark"
        data-dismiss="modal"
        (click)="close()"
      >
        Close
      </button>
    </div>
  </div>
</div>

<ng-template #loading>
  <div>Loading</div>
</ng-template>
